import isOmpPlatform from '../../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const colors = {
  WHITE: '#FFF',
  LIGHTER_GREY: '#F5F5F5',
  LIGHT_GREY: '#F9F9F9',
  LIGHT_GREY_2: '#E7E7E7',
  LIGHT_GREY_3: '#E5E5E5',
  LIGHT_GREY_4: '#A6A6A6',
  LIGHT_GREY_5: '#C8C8C8',
  LIGHT_GREY_6: '#696969',
  LIGHT_GREY_7: '#C3C3C3',
  LIGHT_GREY_8: '#D7D7D7',
  LIGHT_GREY_9: '#B6B6B6',
  LINE_GREY: '#DBDBDB',
  MID_GREY: '#AEAEAE',
  DEEP_GREY: '#707070',
  SILVER_GREY: '#757575',
  BOULDER_GREY: '#7D7D7D',
  DARK_GREY: '#333',
  DARKER_GREY: '#979797',
  DARKEST_GREY: '#191919',
  GREY_BLACK: '#1A1A1A',
  BLACK: '#000',
  SCARLET: '#FF1A00',
  BRAND_GREEN: '#82BC00',
  JADE: '#00b43d',
  ACTION_BLUE: isOmp ? '#0061FF' : '#0020ff',
  DARK_BLUE: isOmp ? '#1131A6' : '#00149F',
  DARK_BLUE_2: '#0A1B5F',
  WHITE_LILAC: '#EDF4FF',
  YELLOW: '#FFC827',
  TRANSPARENT: 'transparent',
  RED: isOmp ? '#d0130f' : '#ff0000',
  SUNSET_ORANGE: '#F95341',
  PALE_ORANGE: '#FFF1BE',
  FUN_GREEN: '#008415',
  SCIENCE_BLUE: '#0064bc',
  BRIGHT_SUN: '#FBCA1F',
  MONZA: '#dd0000',
  LA_PALMA: isOmp ? '#007828' : '#0da400',
  LIMEADE: '#f4f8e7',
  ALTO: '#d1d1d1',
  LIGHT_SILVER: '#D8D8D8',
  DODGER_BLUE: '#3AA0FF',
  FLUSH_ORANGE: '#FF7A00',
  SILVER: '#C4C4C4',
  CRISP_BLUE: 'rgb(5, 114, 206)',
  FADED_BLUE: 'rgba(5, 114, 206, 0.2)',
  FADED_BLACK: 'rgba(0, 0, 0, 0.2)',
  INFO_BLUE: '#027ABB'
};

export default colors;
